import React from 'react';
import { Balance } from '../../../Balance/Balance';
import styles from './AccountBalance.module.scss';

export const AccountBalance = props => (
    <span className={styles['container']}>
        <Balance {...props} />
    </span>
);
